var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticStyle: { "enable-background": "new 0 0 1500 1500" },
      attrs: {
        width: "100%",
        height: "100%",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0",
        y: "0",
        viewBox: "100 75 1300 1350",
        "xml:space": "preserve",
      },
    },
    [
      _c(
        "g",
        { attrs: { transform: "matrix(1.57 0 0 1.57 121 440)" } },
        [
          _c("path", {
            staticStyle: { fill: "#e6e6e6" },
            attrs: {
              d: "m672.9 476.9 12.2-3.8c1-.7 2.1-1.1 3.1-2l-19 6.1c1.3 0 2.5 0 3.7-.3zm-8.6 0 27.6-9c.5-.4.9-1 1.4-1.4l-30.9 9.8c.6.4 1.3.5 1.9.6zm-4.9-1.2 36.1-11.6c.4-.3.5-.8 1-1.2L658.4 475c.4.5.7.5 1 .7zm-2.8-1.8 41.5-13.3c.2-.3.4-.8.7-1.1L656 473.2c.1.4.4.6.6.7zm-2.1-2.1 45.2-14.4c.2-.3.2-.7.4-1.1L654 471.2c.3.2.4.5.5.6zm-1.3-2.2 48-15.3c0-.3.2-.7.2-1.1l-48.7 15.6c.2.3.3.6.5.8zm-1.2-2.4 49.9-16c0-.3.1-.7.2-1.1l-50.4 16c.1.6.2.8.3 1.1zm-.8-2.4 51.4-16.5c0-.3.1-.7.1-1L650.8 464c.1.2.2.5.4.8zm-.5-2.9c.1.1-.1.2 0 .3l52.3-16.7c0-.3.1-.7.1-1L651 461.1c-.1.2-.2.5-.3.8zm2.7-3.7c-.1.1-.2.3-.4.3l50.1-16c0-.3-.1-.5 0-.9l-48.8 15.7c-.4.3-.6.7-.9.9zm2.4-3.2 46.8-15c0-.3-.1-.5-.2-.9L656.3 454c0 .3-.2.6-.5 1zm1.6-3.3 45.1-14.4c-.1-.3-.1-.5-.2-.9l-44.4 14.3c-.4.5-.4.8-.5 1zm.7-2.9 43.7-13.9c-.1-.3-.2-.4-.2-.9l-43.1 13.9c-.3.3-.4.6-.4.9zm.3-2.9 42.5-13.5c-.1-.3-.2-.4-.3-.8L658.4 445v.9zm-.3-2.7 41.3-13.2c-.1-.3-.2-.4-.3-.8l-41 13.1v.9zm-.5-2.5 40.3-13c-.1-.3-.4-.5-.5-.7l-40.2 12.9.4.8zm37.8-15.7-39.2 12.4c.1.3.2.4.3.8l39.5-12.7c0-.1-.3-.3-.6-.5zm-2.3-2-38.2 12.2c.1.3.4.5.5.7l38.5-12.3c-.3 0-.6-.4-.8-.6zm-3.1-1.7-36.5 11.6c.1.3.2.4.3.8l37.2-12c-.3-.1-.5-.3-1-.4zm-3.8-1.4c-.1.1-.2-.1-.3 0l-32.2 10.3c-.1.2-.1.7-.1 1l34.1-10.9c-.6-.1-1.1-.3-1.5-.4zm-8.2-.4-20.9 6.7-2.1 1.5 26.4-8.4c-1 .1-2.3.1-3.4.2z",
            },
          }),
          _c("path", {
            staticClass: "st1",
            attrs: {
              d: "M734.7 291.8c1.5 4.6-.2 9.5-2.5 13.8-6.2 11.7-16.3 21.3-28.3 26.9-6.7 3.2-13.9 5-20.7 7.9-20 8.3-36.2 24.9-44 45.1 2.3-14-5-27.8-14-38.9-8.8-11-19.5-21-25.9-33.6-5.5-10.9-5.6-27.1 5.5-32.3 8.1-3.8 18.2.4 26.5-3.1 2.9-1.3 5.6-3.9 5.5-7.1-.4-8.1-16.4-7.5-16.8-15.6-.4-9.3 24-6.6 20.9-15.4-1.3-3.7-6.5-4.8-8.3-8.3-1.9-3.5-1.7-8.4 1.4-10.9 4-3.3 10.2-.7 15.3-1.9 5.8-1.3 9.5-7.2 10.7-13.1s.5-11.9 1.4-17.8c2.1-14.5 14-27.1 28.3-30.1 14.3-3.1 30.2 3.7 38 16.2 3.2 5.1 4.9 12 1.5 16.9-2.9 4.1-9.3 6.9-8.7 11.9.7 6.9 13.4 7.5 13.6 14.4.2 8.1-16.4 8.1-15.9 16.2.2 3.6 4 5.7 6.3 8.5 4.4 5.2 2.6 14.3-3.4 17.6-2.4 1.3-5.2 1.9-7.1 3.7-4.8 4.7-.1 13 5.6 16.5 5.6 3.3 13 6.1 15.1 12.5z",
            },
          }),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "SVGID_1_",
                gradientUnits: "userSpaceOnUse",
                x1: "4726.537",
                y1: "1508.011",
                x2: "6182.383",
                y2: "1508.011",
                gradientTransform: "matrix(.157 0 0 .157 -100.658 66.758)",
              },
            },
            [
              _c("stop", {
                staticStyle: { "stop-color": "#deeafe" },
                attrs: { offset: "0" },
              }),
              _c("stop", {
                staticStyle: { "stop-color": "#e9f1fe" },
                attrs: { offset: "1" },
              }),
            ],
            1
          ),
          _c("path", {
            staticStyle: { fill: "url(#SVGID_1_)" },
            attrs: {
              d: "M692.7 292.3c3.4-1.9 7-3.6 9.7-6.4 5.6-6.1 5.2-15.3 5.7-23.6.4-8.3 3.4-18 11.4-20.2 6.7-1.9 15.1 2.2 20-2.6 1.9-1.7 2.6-4.4 3.9-6.6 5.7-9.5 20.6-8.7 28.9-1.4 8.2 7.3 11.4 18.7 14.1 29.4 1 3.9 1.1 9.4-2.7 10.5-3.7 1-7.4-3.6-10.9-2.2-2.8 1.1-3.1 5.1-2 8.1 1 2.8 2.7 5.8 2.1 8.8-1.3 5.7-9.3 6-15 4.5-5.7-1.5-13-3.1-16.3 1.9 3.6 11.5 6.7 25.4-1.4 34.5-9.3 10.4-26.4 9.3-40.3 10.6-25.8 2.4-44 22.1-58.5 43.6-.8-36.1 19.8-71.7 51.3-88.9z",
            },
          }),
          _c("path", {
            staticClass: "st3",
            attrs: {
              d: "M660.4 364.7h-.2c-.3-.1-.4-.4-.3-.7 13.1-40.1 34-67.9 72.1-96 7.1-5.2 28.5-14.1 37.8-14.8.2 0 .5.2.5.5s-.2.5-.5.5c-8.8.8-30.3 9.6-37.1 14.6-38 27.9-58.7 55.6-71.7 95.4-.1.3-.4.5-.6.5zM680.6 247.3l-4.4-12c-1.5-.1-3.2.1-4.7.7l4.7 12.9c.2.8-.1 1.5-.9 1.7-.8.2-1.5-.1-1.7-.9l-4.7-12.7c-1.4.9-2.6 2.1-3.6 3.4l3.9 10.7c.2.8-.1 1.5-.9 1.7-.8.2-1.5-.1-1.7-.9l-3.1-8.4c-1.7 4.4-1.9 9.9.1 15.4 0 .1.1.2.1.3-1 .5-2.1 1.2-2.9 2-2.7 2-6.2 5.3-7.4 10.2l1.3.3c1.1-4.4 4.4-7.5 6.9-9.3.9-.7 1.7-1.2 2.7-1.7 2.1 4.6 5.5 8.3 9.2 10.3l-2.9-8c-.2-.8.1-1.5.9-1.7s1.5.1 1.7.9l3.8 10.3c1.6.4 3.3.5 4.9.2l-4.4-12c-.2-.8.1-1.5.9-1.7.8-.2 1.5.1 1.7.9l4.5 12.1c1.4-.7 2.7-1.6 3.8-2.7l-4-10.9c-.2-.8.1-1.5.9-1.7.8-.2 1.5.1 1.7.9l3.5 9.4c1.1-1.6 2.1-3.4 2.9-5.2l-2.2-5.9c-.2-.8.1-1.5.9-1.7.8-.2 1.5.1 1.7.9l1.2 3.2c2.2-5.2 3.6-10.4 5.5-12-3.1-.7-7.3-3.5-12-6.1l1.5 4c.2.8-.1 1.5-.9 1.7-.8.2-1.5-.1-1.7-.9l-2.5-6.9c-1.9-.9-3.7-1.5-5.6-2l3.8 10.6c.2.8-.1 1.5-.9 1.7-.5-.1-1.2-.4-1.6-1.1z",
            },
          }),
          _c("path", {
            staticStyle: { fill: "#d6d7d8" },
            attrs: { d: "M342.9 381h121.8v135.5H342.9z" },
          }),
          _c("path", {
            staticClass: "st5",
            attrs: { d: "M267.4 512.1h272.7v10.5H267.4z" },
          }),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "SVGID_2_",
                gradientUnits: "userSpaceOnUse",
                x1: "1508.598",
                y1: "1454.905",
                x2: "6860.149",
                y2: "1454.905",
                gradientTransform: "matrix(.157 0 0 .157 -100.658 66.758)",
              },
            },
            [
              _c("stop", {
                staticStyle: { "stop-color": "#eee" },
                attrs: { offset: "0" },
              }),
              _c("stop", {
                staticStyle: { "stop-color": "#d6d7d8" },
                attrs: { offset: "1" },
              }),
            ],
            1
          ),
          _c("path", {
            staticStyle: { fill: "url(#SVGID_2_)" },
            attrs: { d: "M136.2 121.9h535.2v346.5H136.2z" },
          }),
          _c("path", {
            staticClass: "st3",
            attrs: { d: "M145.6 130.5H662v285.4H145.6z" },
          }),
          _c("path", {
            staticClass: "st1",
            attrs: {
              transform: "rotate(-45.001 384.576 442.716)",
              d: "M379.6 437.7h9.9v9.9h-9.9z",
            },
          }),
          _c("path", {
            staticClass: "st3",
            attrs: {
              transform: "rotate(-45.001 403.739 442.701)",
              d: "M398.8 437.7h9.9v9.9h-9.9z",
            },
          }),
          _c("path", {
            staticClass: "st1",
            attrs: {
              transform: "rotate(-45.001 422.901 442.731)",
              d: "M417.9 437.8h9.9v9.9h-9.9z",
            },
          }),
          _c(
            "g",
            [
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d: "M61.4 450.3c-.2 4.8 2.7 9.2 6.1 12.7 9.2 9.7 21.5 16.4 34.6 18.6 7.3 1.2 14.8 1.2 22.3 2.1 21.6 2.7 41.8 14.5 54.8 32-6-13-2.5-28.4 3.2-41.5 5.7-13.1 13.4-25.5 16.2-39.5 2.4-12-1.9-27.8-14-29.9-9-1.5-17.7 5.3-26.6 4-3.2-.4-6.6-2.3-7.2-5.5-1.7-8 14-11.7 12.1-19.7-2.1-9.2-25.1 0-24.3-9.3.3-3.9 5-6.3 5.9-10.3s-.5-8.6-4.3-10.2c-4.8-2.1-10 2.1-15.3 2.3-6 .3-11.1-4.5-13.9-9.8s-3.7-11.5-6.1-16.9c-5.9-13.5-20.7-22.6-35.5-21.7-14.7.9-28.4 11.7-32.6 25.9-1.7 5.8-1.6 13 3.1 16.9 3.9 3.3 10.8 4.1 11.7 9.2 1.2 6.9-11 10.9-9.4 17.7 1.9 8 18.1 3.5 19.8 11.5.8 3.6-2.4 6.7-3.8 9.9-2.8 6.2 1.3 14.5 8 16.2 2.6.7 5.6.3 8 1.6 5.9 3.3 3.6 12.6-1 17.5-5 5-11.4 9.4-11.8 16.2z",
                },
              }),
              _c(
                "linearGradient",
                {
                  attrs: {
                    id: "SVGID_3_",
                    gradientUnits: "userSpaceOnUse",
                    x1: "1928.832",
                    y1: "1970.189",
                    x2: "3395.888",
                    y2: "1970.189",
                    gradientTransform:
                      "matrix(-.1513 .0416 .0416 .1513 365.416 58.357)",
                  },
                },
                [
                  _c("stop", {
                    staticStyle: { "stop-color": "#deeafe" },
                    attrs: { offset: "0" },
                  }),
                  _c("stop", {
                    staticStyle: { "stop-color": "#e9f1fe" },
                    attrs: { offset: "1" },
                  }),
                ],
                1
              ),
              _c("path", {
                staticStyle: { fill: "url(#SVGID_3_)" },
                attrs: {
                  d: "M102.5 439.7c-3.8-.9-7.8-1.6-11.1-3.7-7.1-4.5-9.2-13.5-11.8-21.4-2.6-7.9-8.1-16.6-16.4-16.6-7 0-14.1 6.2-20.1 2.8-2.3-1.3-3.7-3.6-5.6-5.3-8-7.6-22.4-2.9-28.4 6.3s-6 21.2-5.9 32.3c.1 4 1.4 9.4 5.5 9.4 3.8 0 6.2-5.5 10-5 3.1.3 4.4 4.3 4.1 7.3-.2 3.1-1.1 6.3.3 9.1 2.7 5.2 10.7 3.4 15.7.3s11.8-6.4 16.3-2.5c-.4 12.1.3 26.5 10.6 33.1 11.8 7.5 28.2 2 41.9-.4 25.7-4.6 48.7 9.7 68.4 26.7-8.9-35.2-38.4-64.2-73.5-72.4z",
                },
              }),
              _c("path", {
                staticClass: "st8",
                attrs: { d: "M178.9 517.2c-8.7-22.8-15.7-46.3-21.1-70.1" },
              }),
              _c("ellipse", {
                staticClass: "st9",
                attrs: {
                  transform: "rotate(-12.916 157.59 444.737)",
                  cx: "157.6",
                  cy: "444.7",
                  rx: "12.4",
                  ry: "4.7",
                },
              }),
              _c("path", {
                staticClass: "st8",
                attrs: { d: "M157.2 444.3c-2.9-13.5-5.3-27.1-7.2-40.8" },
              }),
              _c("ellipse", {
                staticClass: "st9",
                attrs: {
                  transform: "rotate(-18.504 149.515 400.306)",
                  cx: "149.5",
                  cy: "400.3",
                  rx: "15",
                  ry: "5.6",
                },
              }),
              _c("path", {
                staticClass: "st8",
                attrs: { d: "M149.4 399.9c-1.4-11.4-2.5-22.7-3.3-34.1" },
              }),
              _c("ellipse", {
                staticClass: "st9",
                attrs: {
                  transform: "matrix(.9999 -.0106 .0106 .9999 -3.828 1.577)",
                  cx: "146.9",
                  cy: "361.9",
                  rx: "15",
                  ry: "5.6",
                },
              }),
              _c("path", {
                staticClass: "st8",
                attrs: { d: "M145.9 361c-.4-8.6-.7-17.4-.8-26.1" },
              }),
              _c("ellipse", {
                staticClass: "st9",
                attrs: {
                  transform: "matrix(.9999 -.0106 .0106 .9999 -3.495 1.558)",
                  cx: "145.2",
                  cy: "330.4",
                  rx: "20.1",
                  ry: "7.5",
                },
              }),
              _c("path", {
                staticClass: "st8",
                attrs: { d: "M145.1 329c.1-5.8.2-11.6.4-17.4" },
              }),
            ],
            1
          ),
          _c("path", {
            staticClass: "st3",
            attrs: {
              d: "m132.8 484.9 4.4-12c1.5-.1 3.2.1 4.7.7l-4.7 12.9c-.2.8.1 1.5.9 1.7s1.5-.1 1.7-.9l4.7-12.7c1.4.9 2.6 2.1 3.6 3.4l-3.9 10.7c-.2.8.1 1.5.9 1.7s1.5-.1 1.7-.9l3.1-8.4c1.7 4.4 1.9 9.9-.1 15.4 0 .1-.1.2-.1.3 1 .5 2.1 1.2 2.9 2 2.7 2 6.2 5.3 7.4 10.2l-1.3.3c-1.1-4.4-4.4-7.5-6.9-9.3-.9-.7-1.7-1.2-2.7-1.7-2.1 4.6-5.5 8.3-9.2 10.3l2.9-8c.2-.8-.1-1.5-.9-1.7-.8-.2-1.5.1-1.7.9l-3.8 10.3c-1.6.4-3.3.5-4.9.2l4.4-12c.2-.8-.1-1.5-.9-1.7s-1.5.1-1.7.9l-4.5 12.1c-1.4-.7-2.7-1.6-3.8-2.7l4-10.9c.2-.8-.1-1.5-.9-1.7-.8-.2-1.5.1-1.7.9l-3.5 9.4c-1.1-1.6-2.1-3.4-2.9-5.2l2.2-5.9c.2-.8-.1-1.5-.9-1.7s-1.5.1-1.7.9l-1.2 3.2c-2.2-5.2-3.6-10.4-5.5-12 3.1-.7 7.3-3.5 12-6.1l-1.5 4c-.2.8.1 1.5.9 1.7s1.5-.1 1.7-.9l2.5-6.9c1.9-.9 3.7-1.5 5.6-2l-3.8 10.6c-.2.8.1 1.5.9 1.7.5 0 1.3-.3 1.6-1.1z",
            },
          }),
          _c("path", {
            staticStyle: { fill: "#b3c9ee" },
            attrs: {
              d: "m109.6 136-8.2-1c-.8.1-1.5.1-2.3.3l12.8 1.4c-.9-.1-1.6-.5-2.3-.7zm5 2.3L96 136.2c-.4.1-.8.3-1.2.4l20.7 2.4c-.3-.3-.6-.5-.9-.7zm2.5 2-24.2-2.7c-.3.1-.5.3-.9.4l25.5 2.9c-.1-.3-.3-.4-.4-.6zm1.2 1.8L90.4 139c-.2.1-.4.3-.7.4l28.7 3.3c.1-.3 0-.5-.1-.6zm.6 1.8-30.3-3.5c-.2.1-.3.3-.5.5l31 3.5c-.2-.2-.2-.4-.2-.5zm.3 1.6L87 141.8c-.1.2-.3.3-.4.5l32.6 3.7v-.5zm0 1.8-33.5-3.8c-.1.2-.2.3-.4.5l33.8 3.9c.1-.3.1-.4.1-.6zm-.1 1.6L84.6 145c-.1.2-.2.3-.3.5l34.8 3.9v-.5zm-.6 1.8c0-.1.1-.1.1-.2l-35-4c-.1.2-.2.3-.3.5l34.9 4c.1 0 .2-.1.3-.3zm-2.5 1.5c.1 0 .2-.1.3-.1l-33.6-3.8c-.1.2-.1.3-.2.5l32.8 3.7c.3-.1.5-.2.7-.3zm-2.3 1.2-31.4-3.6c-.1.2-.1.3-.1.5l31 3.5c.1-.1.3-.2.5-.4zm-1.7 1.5-30.2-3.5c0 .2-.1.3-.1.5l29.8 3.4c.2-.1.3-.3.5-.4zm-1.2 1.5L81.5 153c0 .2 0 .3-.1.5l28.9 3.3c.2 0 .3-.2.5-.4zm-.9 1.7-28.5-3.3v.5l28.3 3.3c0-.2.1-.4.2-.5zm-.7 1.6-27.7-3.2v.5l27.5 3.2c.1-.2.2-.4.2-.5zm-.3 1.6-27.1-3.1c0 .2.1.4.1.5l27 3.1v-.5zm-26.3-.7 26.3 3.1v-.5L82.4 160c0 .1.1.4.2.6zm.9 1.7 25.7 2.9c0-.2-.1-.4-.1-.5l-25.9-2.9c0 .1.2.3.3.5zm1.3 1.9 24.5 2.8v-.5l-25-2.8c.1 0 .3.3.5.5zm1.8 1.8c.1 0 .1.1.2.1l21.6 2.5c.1-.1.2-.3.3-.5L86 165.5c.2.1.4.3.6.5zm4.7 2.3 14 1.6c.5-.1 1.1-.2 1.6-.3l-17.7-2.1c.7.3 1.5.6 2.1.8z",
            },
          }),
          _c("path", {
            staticClass: "st1",
            attrs: {
              d: "m687.1 497.3 12.8.5c1.2-.2 2.4-.3 3.5-.8l-20-.7c1.4.3 2.5.7 3.7 1zm-8.1-3 29 1c.7-.2 1.1-.5 1.9-.9l-32.4-1.2c.5.6.9.9 1.5 1.1zm-4-2.7 37.9 1.3c.5-.2.8-.5 1.3-.8l-40-1.5c.2.5.5.6.8 1zm-2.2-2.8 43.6 1.5c.3-.2.7-.5 1-.8l-44.9-1.6c-.1.5.2.8.3.9zm-1.2-2.6 47.5 1.7c.3-.2.4-.5.8-.9l-48.5-1.7c.2.4.2.7.2.9zm-.6-2.5 50.3 1.9c.1-.3.4-.5.7-.9l-51.1-1.9c.1.3.1.6.1.9zm-.2-2.7 52.4 2c.1-.3.3-.5.7-.9L671 480c-.2.6-.2.7-.2 1zm0-2.5 53.9 2c.1-.3.3-.5.4-.9l-54.5-2c.2.2.2.5.2.9zm.7-3c0 .2-.1.2-.1.3l54.8 2.1c.1-.3.3-.5.4-.9l-54.6-2c-.2.2-.4.3-.5.5zm3.7-2.5c-.2 0-.3.2-.5.2l52.6 1.9c.1-.3.1-.5.3-.9l-51.2-1.9c-.6.3-.9.5-1.2.7zm3.4-2.2 49.1 1.9c.1-.3.1-.5.1-.9l-48.5-1.7c-.1.2-.4.4-.7.7zm2.5-2.5 47.3 1.7c0-.3.1-.5.1-.9l-46.6-1.6c-.5.3-.6.6-.8.8zm1.7-2.5 45.7 1.7c0-.3 0-.5.1-.9l-45.2-1.6c-.4.3-.5.5-.6.8zm1.1-2.6 44.5 1.6c0-.3 0-.5-.1-.9l-44.2-1.7c.1.4 0 .8-.2 1zm.9-2.6 43.3 1.6c0-.3 0-.5-.1-.9l-43-1.6c-.1.3-.2.7-.2.9zm.3-2.6 42.4 1.5c0-.3-.2-.7-.2-.9l-42.1-1.5c-.2.3-.1.6-.1.9zm40.8-2-41.2-1.6c0 .3 0 .5.1.9l41.5 1.5c.1-.2-.1-.5-.4-.8zm-1.5-2.6-40.1-1.5c0 .3.2.7.2.9l40.5 1.5c-.3-.3-.4-.6-.6-.9zm-2.3-2.8-38.2-1.5c0 .3 0 .5.1.9l39.1 1.4c-.4-.1-.7-.4-1-.8zm-3-2.6c-.2 0-.2-.1-.3-.1l-33.8-1.3c-.1.2-.3.5-.4.9l35.7 1.3c-.6-.1-.9-.5-1.2-.8zm-7.6-2.9-21.8-.9c-.9.2-1.6.4-2.5.7l27.6 1.1c-1.1-.3-2.3-.7-3.3-.9z",
            },
          }),
        ],
        1
      ),
      _c("path", {
        staticClass: "st5",
        attrs: {
          d: "M95.3 205.8c14.7 8.7 25.2 21.5 30.4 35.3 20.5-13.6 41.6-36.2 58.5-64.9 34.5-58.5 9.5-137.1 9.5-137.1s-80.9 16.2-115.4 74.6c-16.9 28.7-26.6 58-28.6 82.6 14.6-2.2 30.9.8 45.6 9.5z",
          transform: "matrix(1.78529 -1.03467 1.03506 1.78461 367.483 426.507)",
        },
      }),
      _c("path", {
        staticStyle: { fill: "#efefef" },
        attrs: {
          d: "M159.1 129.1c3.9 2.3 7.1 5.4 9.4 8.9.9-10.8-4.3-21.7-14.2-27.6-13.9-8.2-31.7-3.6-39.9 10.3-5.9 10-5.2 22 .9 31 .4-4.2 1.6-8.5 3.9-12.4 8.1-13.7 26-18.3 39.9-10.2z",
          transform: "matrix(1.78529 -1.03467 1.03506 1.78461 367.483 426.507)",
        },
      }),
      _c("path", {
        staticClass: "st3",
        attrs: {
          d: "M164.5 150.4c2.3-3.9 3.6-8.1 3.9-12.4-2.4-3.5-5.5-6.6-9.4-8.9-13.9-8.2-31.7-3.6-39.9 10.3-2.3 3.9-3.6 8.1-3.9 12.4 2.4 3.5 5.5 6.6 9.4 8.9 13.9 8.2 31.8 3.6 39.9-10.3z",
          transform: "matrix(1.78529 -1.03467 1.03506 1.78461 367.483 426.507)",
        },
      }),
      _c("path", {
        staticClass: "st12",
        attrs: {
          d: "M170.2 177.3 121.8 237l19.2 42.2c26.3-37.3 35.2-71.1 29.2-101.9zM86.9 128.1 58 199.4 11.8 203c20-41.1 45.2-65.2 75.1-74.9z",
          transform: "matrix(1.78529 -1.03467 1.03506 1.78461 367.483 426.507)",
        },
      }),
      _c("path", {
        staticStyle: { fill: "#ff4945" },
        attrs: {
          d: "M190.6 46.8c-.3 0-.5-.1-.8-.2-.7-.4-1-1.4-.5-2.1L215 .8c.4-.7 1.4-1 2.1-.5.7.4 1 1.4.5 2.1L191.9 46c-.3.5-.8.8-1.3.8z",
          transform: "matrix(1.78529 -1.03467 1.03506 1.78461 367.483 426.507)",
        },
      }),
      _c("path", {
        staticClass: "st1",
        attrs: {
          d: "M81.6 328.2h-.1c-.3-.1-.4-.4-.3-.6 6.6-22.4 11.3-43.1 15.4-67 0-.3.3-.5.6-.4.3 0 .5.3.4.6-4.1 24-8.8 44.7-15.4 67.2-.1.1-.4.2-.6.2zM.5 280.3c-.1 0-.3 0-.4-.1-.2-.2-.2-.5 0-.7 16.4-16.6 32.3-30.8 51.3-46 .2-.2.5-.1.7.1.2.2.1.5-.1.7-19 15.2-34.8 29.3-51.2 45.9 0 .1-.2.1-.3.1z",
          transform: "matrix(1.78529 -1.03467 1.03506 1.78461 367.483 426.507)",
        },
      }),
      _c("path", {
        staticClass: "st12",
        attrs: {
          transform: "matrix(-1.3131 1.5913 -1.5919 -1.3126 1505.363 1284.204)",
          d: "M71 336.2h12v12.1H71z",
        },
      }),
      _c("path", {
        staticStyle: { fill: "#1b236d" },
        attrs: {
          transform: "matrix(-.6334 1.9633 -1.964 -.6332 1399.36 1207.297)",
          d: "M4.3 329.7h12v12.1h-12z",
        },
      }),
      _c("path", {
        staticClass: "st1",
        attrs: {
          transform: "matrix(-1.3131 1.5913 -1.5919 -1.3126 1069.56 1169.144)",
          d: "M9.4 247.2h8.2v8.2H9.4z",
        },
      }),
      _c("path", {
        staticClass: "st1",
        attrs: {
          d: "M20.5 323.7c-.1 0-.2 0-.3-.1-.2-.1-.3-.5-.2-.7l36.7-62.3c.1-.2.5-.3.7-.2.2.1.3.5.2.7l-36.7 62.3c-.1.2-.2.3-.4.3zM61 311.7h-.2c-.3-.1-.4-.4-.3-.7l6.3-16.9c.1-.3.4-.4.7-.3.3.1.4.4.3.7l-6.3 16.9c-.1.2-.3.3-.5.3z",
          transform: "matrix(1.78529 -1.03467 1.03506 1.78461 367.483 426.507)",
        },
      }),
      _c("path", {
        staticClass: "st12",
        attrs: {
          d: "M139.4 169.9c-6.1 0-12.1-1.6-17.4-4.8-7.9-4.7-13.5-12.1-15.8-21-2.3-8.9-1-18.1 3.7-26 6.1-10.4 17.5-16.9 29.6-16.9 6.1 0 12.1 1.6 17.4 4.8 16.3 9.6 21.7 30.7 12.1 47-6.2 10.4-17.5 16.9-29.6 16.9zm.1-58.3c-8.5 0-16.4 4.5-20.7 11.8-3.3 5.5-4.2 12-2.6 18.2 1.6 6.2 5.5 11.4 11 14.7 3.7 2.2 7.9 3.3 12.2 3.3 8.5 0 16.4-4.5 20.7-11.8 6.7-11.4 2.9-26.1-8.5-32.8-3.7-2.2-7.9-3.4-12.1-3.4z",
          transform: "matrix(1.78529 -1.03467 1.03506 1.78461 367.483 426.507)",
        },
      }),
      _c("path", {
        staticClass: "st1",
        attrs: {
          d: "M133.8 76.8c29.6 17.5 51 42.9 62.5 70.7 15.1-52.6-2.6-108.4-2.6-108.4S156 46.6 121.1 70c4.3 2.1 8.5 4.3 12.7 6.8z",
          transform: "matrix(1.78529 -1.03467 1.03506 1.78461 367.483 426.507)",
        },
      }),
      _c("path", {
        staticClass: "st12",
        attrs: {
          d: "M204.1 103.1c.9-36.8-8.7-66.9-8.7-66.9s-31 6.2-62.8 24.8l71.5 42.1z",
          transform: "matrix(1.78529 -1.03467 1.03506 1.78461 367.483 426.507)",
        },
      }),
      _c("path", {
        staticClass: "st1",
        attrs: {
          d: "m76.4 47.7-40.9-41c-6.6 2.7-12.7 6.4-18 11.4l44.2 44.3c2.5 2.5 2.5 6.5 0 9s-6.5 2.5-9 0L9.4 27.9c-4.1 6.3-6.9 13.5-8.3 21l36.6 36.7c2.5 2.5 2.5 6.5 0 9s-6.5 2.5-9 0L0 65.8c1.1 21.5 11.2 44.6 29.8 63.2l1.3 1.3c-3.1 4.4-6 9-8.6 13.7-7.3 13.3-15.2 33.9-11.3 55.9l6.2-1.1c-3.6-20.2 3.7-39.3 10.6-51.7 2.4-4.3 5-8.4 7.8-12.5 17.5 15.1 38.1 23.6 57.4 24.7L65.9 132c-2.5-2.5-2.5-6.5 0-9s6.5-2.5 9 0l35.2 35.3c7.6-1.5 14.6-4.3 20.8-8.5l-40.9-41c-2.5-2.5-2.5-6.5 0-9s6.5-2.5 9 0l41.4 41.6c4.7-5.4 8.1-11.7 10.6-18.7L113.6 85c-2.5-2.5-2.5-6.5 0-9s6.5-2.5 9 0l32.1 32.3c1.6-8.7 2.2-17.9 2.2-27.2l-20.2-20.3c-2.5-2.5-2.5-6.5 0-9s6.5-2.5 9 0l10.7 10.8c-1.3-25.9-4.8-49.7-.7-60.1-13.6 3.1-36.8-.5-61.2-2l13.9 14c2.5 2.5 2.5 6.5 0 9s-6.5 2.5-9 0L76.1 0C67 .1 57.9.8 49.4 2.5l36 36.1c2.5 2.5 2.5 6.5 0 9-2.5 2.6-6.5 2.6-9 .1z",
          transform: "scale(.61783 .62) rotate(24.098 -2547.173 5972.351)",
        },
      }),
      _c("g", [
        _c("path", {
          staticClass: "st1",
          attrs: {
            d: "M171 87.3c0 2.4-2 4.4-4.4 4.4s-4.4-2-4.4-4.4v-23c-4.5-4.5-9.3-8.6-14.4-11.9v35.4c0 2.4-2 4.4-4.4 4.4s-4.4-2-4.4-4.4V47.6c-4.6-1.9-9.4-3.1-14.4-3.3v43.4c0 2.4-2 4.4-4.4 4.4s-4.4-2-4.4-4.4V45.2c-5.1 1.1-9.9 3.2-14.4 6.2v35.9c0 2.4-2 4.4-4.4 4.4-2.4 0-4.4-2-4.4-4.4V59.1c-10 11-16.3 27.3-16.3 45.6s6.3 34.8 16.3 46v-26.8c0-2.4 2-4.4 4.4-4.4 2.4 0 4.4 2 4.4 4.4v34.5c4.4 3 9.3 5.1 14.4 6v-40.1c0-2.4 2-4.4 4.4-4.4s4.4 2 4.4 4.4V165c4.9-.3 9.7-1.7 14.4-4v-36.7c0-2.4 2-4.4 4.4-4.4s4.4 2 4.4 4.4v31.6c5-3.5 9.8-7.7 14.4-12.2v-19.8c0-2.4 2-4.4 4.4-4.4s4.4 2 4.4 4.4v10.6c12-13.3 21.9-26.7 29-29.7-8.2-5.1-17.8-18.3-29-31.1v13.6z",
            transform: "matrix(-.6 0 0 .6 305 727)",
          },
        }),
        _c("path", {
          staticClass: "st1",
          attrs: {
            d: "m88.9 107.7-8.9.5c-12.6.7-25.6 1.4-37.8 5-9.4 2.7-22.4 8.4-30.4 20.1l-3.6-2.5C17 118.1 30.9 111.9 41 109c12.7-3.7 25.9-4.4 38.8-5.1l8.9-.5.2 4.3z",
            transform: "matrix(-.6 0 0 .6 305 727)",
          },
        }),
        _c("path", {
          staticClass: "st1",
          attrs: {
            d: "m37.6 56.1-4.9 7.5C25.8 74.1 18.6 85 14.2 97c-3.4 9.2-6.5 23-1.9 36.5l-4.2 1.4c-5-14.7-1.7-29.6 2-39.4C14.7 83.1 21.9 71.9 29 61.2l4.9-7.5 3.7 2.4z",
            transform: "matrix(-.6 0 0 .6 305 727)",
          },
        }),
        _c("path", {
          staticClass: "st1",
          attrs: {
            d: "M79.9 14.3c1.4 2 1 4.7-.9 6.2s-4.7 1-6.2-.9L59.1 1.1C52.8.2 46.5-.2 40.5.1l21 28.4c1.4 2 1 4.7-.9 6.2-2 1.5-4.7 1-6.2-.9L30.6 1.6c-4.8 1.2-9.4 3.1-13.5 6L43 42.4c1.4 2 1 4.7-.9 6.2-2 1.5-4.7 1-6.2-.9L10.6 13.4C7.1 17.3 4.5 21.9 2.7 27l21.4 28.8c1.4 2 1 4.7-.9 6.2-2 1.5-4.7 1-6.2-.9L.3 38.4c-1.4 14.8 3.2 31.7 14.1 46.3C25.2 99.4 40.1 109 54.7 112L38.8 90.4c-1.4-2-1-4.7.9-6.2 2-1.5 4.7-1 6.2.9l20.6 27.7c5.3-.2 10.4-1.5 15.1-3.7L57.6 77c-1.4-2-1-4.7.9-6.2 2-1.5 4.7-1 6.2.9l24.2 32.7c3.8-3.2 6.8-7.2 9.2-11.8L76.2 63.1c-1.4-2-1-4.7.9-6.2s4.7-1 6.2.9l18.8 25.4c1.9-5.8 3.3-12 4.3-18.4L94.6 48.9c-1.4-2-1-4.7.9-6.2 2-1.5 4.7-1 6.2.9l6.3 8.5c1.7-17.9 1.8-34.5 5.6-41.2-9.7.8-25.2-4.1-41.8-7.6l8.1 11z",
            transform: "matrix(-.6 0 0 .6 305 727)",
          },
        }),
      ]),
      _c("g", [
        _c("g", { attrs: { transform: "matrix(1.74 0 0 1.74167 877 782)" } }, [
          _c("circle", {
            staticClass: "st15",
            attrs: { cx: "68.4", cy: "115", r: "5" },
          }),
          _c("path", {
            staticClass: "st1",
            attrs: { d: "m0 14.4 1.5-4.9L6.4 11l-1.5 5z" },
          }),
          _c("path", {
            staticClass: "st12",
            attrs: { d: "m27.6 29.9 4.2-13.4 13.4 4.2L41 34.1z" },
          }),
          _c("path", {
            staticClass: "st1",
            attrs: { d: "M7.8 81.1 12 67.6l13.4 4.2-4.2 13.4z" },
          }),
          _c("path", {
            staticClass: "st9",
            attrs: {
              d: "M20 43c-.2 0-.4-.1-.5-.3C12.9 28.5 17 10.2 28.9.1c.2-.2.6-.2.8.1.2.2.2.6-.1.8-11.6 9.7-15.5 27.5-9.1 41.2.1.3 0 .6-.3.7 0 .1-.1.1-.2.1zM69.2 97.8c-.1 0-.3-.1-.4-.2-.2-.2-.2-.6 0-.8 8.1-7.8 22.3-8.4 31-1.3.2.2.3.5.1.8-.2.2-.5.3-.8.1-8.3-6.8-21.8-6.2-29.5 1.2-.1.1-.2.2-.4.2z",
            },
          }),
        ]),
      ]),
      _c("g", [
        _c("path", {
          staticClass: "st1",
          attrs: {
            d: "M15.7 104.2 0 97l7.2-15.7 15.7 7.3z",
            transform: "matrix(0 .44269 .44333 0 508.418 801.597)",
          },
        }),
        _c("path", {
          staticClass: "st12",
          attrs: {
            d: "m134.8 124-42.6-19.7 19.7-42.7 42.6 19.7z",
            transform: "matrix(0 .44269 .44333 0 508.418 801.597)",
          },
        }),
        _c("path", {
          staticClass: "st1",
          attrs: {
            d: "m280.3 62.4-42.6-19.7L257.4 0 300 19.7z",
            transform: "matrix(0 .44269 .44333 0 508.418 801.597)",
          },
        }),
        _c("path", {
          staticClass: "st9",
          attrs: {
            d: "M208.5 81.8c-.6 0-1.2-.3-1.6-.9-27.2-42.7-84.1-63.4-132.4-48.3-1 .3-2-.2-2.3-1.2-.3-1 .2-2 1.2-2.3C123.2 13.5 182 34.9 210.1 79c.6.9.3 2-.6 2.6-.3.1-.7.2-1 .2zM12.5 253h-.1c-1-.1-1.8-1-1.7-2 2.4-37.5 36.1-71 73.6-73.1 1-.1 1.9.7 2 1.8.1 1-.7 1.9-1.8 2-35.7 2-67.8 33.9-70.1 69.6-.1.9-1 1.7-1.9 1.7z",
            transform: "matrix(0 .44269 .44333 0 508.418 801.597)",
          },
        }),
      ]),
      _c("g", [
        _c("path", {
          staticClass: "st12",
          attrs: {
            d: "M98.7 98.5c-33.1 2-65.5 2-97.5 0C-.3 64-.5 31.2 1.2 1c32.5-1.4 65-1.4 97.5 0 1.8 31.5 1.7 64.1 0 97.5z",
            transform: "matrix(-.19 0 0 -.19 875 834)",
          },
        }),
      ]),
      _c("g", [
        _c("circle", {
          staticClass: "st9",
          attrs: {
            cx: "50",
            cy: "50",
            r: "50",
            transform: "matrix(.2 0 0 .2 606 978)",
          },
        }),
      ]),
      _c("g", [
        _c("path", {
          staticClass: "st1",
          attrs: {
            d: "M98.7 98.5c-33.1 2-65.5 2-97.5 0C-.3 64-.5 31.2 1.2 1c32.5-1.4 65-1.4 97.5 0 1.8 31.5 1.7 64.1 0 97.5z",
            transform: "rotate(-26.516 2384.8 -1609.191) scale(.16)",
          },
        }),
      ]),
      _c("g", [
        _c("path", {
          staticClass: "st15",
          attrs: {
            d: "m-1415.6 530.6-90.5 134-123.9-83.5 90.5-134.1z",
            transform: "matrix(.08395 0 0 .08732 1063.843 915.968)",
          },
        }),
      ]),
      _c("g", [
        _c("circle", {
          staticClass: "st15",
          attrs: {
            cx: "-1367.6",
            cy: "611.9",
            r: "6.2",
            transform: "translate(3320.252 -306.576) scale(1.86658)",
          },
        }),
      ]),
      _c("g", [
        _c("path", {
          staticClass: "st15",
          attrs: {
            d: "m-1415.6 530.6-90.5 134-123.9-83.5 90.5-134.1z",
            transform: "matrix(.06996 0 0 .07353 766.036 734.13)",
          },
        }),
      ]),
      _c("g", [
        _c("path", {
          staticClass: "st16",
          attrs: {
            d: "m-1867.9 393.7-68-68 68-68.1 68.1 68.1z",
            transform: "matrix(.08818 0 0 .0882 814.71 903.277)",
          },
        }),
      ]),
      _c("g", [
        _c("path", {
          staticClass: "st9",
          attrs: {
            d: "M98.7 98.5c-33.1 2-65.5 2-97.5 0C-.3 64-.5 31.2 1.2 1c32.5-1.4 65-1.4 97.5 0 1.8 31.5 1.7 64.1 0 97.5z",
            transform: "rotate(-20.677 2824.762 -1123.166) scale(.1)",
          },
        }),
      ]),
      _c("g", [
        _c("path", {
          staticClass: "st9",
          attrs: {
            d: "M98.7 98.5c-33.1 2-65.5 2-97.5 0C-.3 64-.5 31.2 1.2 1c32.5-1.4 65-1.4 97.5 0 1.8 31.5 1.7 64.1 0 97.5z",
            transform: "matrix(.11 0 0 .11 750 763)",
          },
        }),
      ]),
      _c("g", [
        _c("path", {
          staticClass: "st9",
          attrs: {
            d: "M98.7 98.5c-33.1 2-65.5 2-97.5 0C-.3 64-.5 31.2 1.2 1c32.5-1.4 65-1.4 97.5 0 1.8 31.5 1.7 64.1 0 97.5z",
            transform: "rotate(-30.985 2036.085 -1380.098) scale(.16)",
          },
        }),
      ]),
      _c("g", [
        _c("circle", {
          staticClass: "st15",
          attrs: {
            cx: "-1367.6",
            cy: "611.9",
            r: "6.2",
            transform: "translate(2459.806 -33.799) scale(1.4608)",
          },
        }),
      ]),
      _c("g", [
        _c("path", {
          staticClass: "st16",
          attrs: {
            d: "m-1867.9 393.7-68-68 68-68.1 68.1 68.1z",
            transform: "matrix(.12492 0 0 .12495 754.838 976.809)",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }